import angular from 'angular';
import dashboardComponent from './dashboard.component';
import DashboardService from './dashboard.service';
// import dashboardConfig from './dashboard.config';

let dashboardModule = angular.module('app.dashboard',[])
  .component('dashboard', dashboardComponent)
  .service('DashboardService', DashboardService);
  // .config(dashboardConfig);
export default dashboardModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/dashboard/dashboard.js
 **/